import request from './request';
import search from './search';

export default {
  RequestInformation: {
    pages: {
      ...request,
      ...search,
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/request_information/index.js